import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AlertLineData } from '../alert-line/alert-line-data';

export class ConnectedPage {

    private _alertLine: AlertLineData = new AlertLineData();

	constructor(private _constantsModule: ConstantsModule, private _cookieService: CookieService, private _httpClient: HttpClient, private _router: Router, private _modalService: NgbModal) {
        // Retrieving data from cookie.
        let token: string = this.cookieService.get(this.constantsModule.cookieToken);

        if (token == "" || token === undefined) {
            // No token, cleaning roles and routing to login.
            this.closeConnexion();
            this.router.navigateByUrl("/login");
        }

        // Testing token validity.
        var newData = {
            "username": this._cookieService.get(this._constantsModule.cookieUser)
        };

        this.put("/secure/check-token", newData,
            (response:any) => {
                if (response.DATA == "ERR" || response.RES == 0) {
                    this.closeConnexion();
                    this.router.navigateByUrl("/login");
                } else {
                }
            },
            (err:any) => {
                this.closeConnexion();
                this.router.navigateByUrl("/login");
            }
        );
	}

    /**
     * Delete all cookies datas.
     */
	public closeConnexion(): void {
		// Purging cookie.
		this._cookieService.delete(this._constantsModule.cookieToken);
		this._cookieService.delete(this._constantsModule.cookieRole);
	}

    /* UTILITIES */
    /**
     * 
     * @param err 
     * @returns 
     */
    public httpErrorToText(err: any): string {
        return "URL: " + err.url + "; Code erreur: " + err.status + " (" + err.statusText + "); Message: " + err.message;
    }

    /* SERVICE HANDLER */
    
     get alertLine(): AlertLineData {
        return this._alertLine;
    }

    get cookieService(): CookieService {
        return this._cookieService;
    }

    get constantsModule(): ConstantsModule {
        return this._constantsModule;
    }

    get httpClient(): HttpClient {
        return this._httpClient;
    }

    get router(): Router {
        return this._router;
    }

    get modalService(): NgbModal {
        return this._modalService;
    }

    /**
     * POST queries handler.
     * @param url 
     * @param data 
     * @param cbOk 
     * @param cbKo 
     */
    public put(url: string, data: any, cbOk: (data: any)=>any, cbKo: (err: any)=>any): void {
        // Reformatting the data to add login values.
        if (data == undefined) {
            data = {
                'access_token': this._cookieService.get(this._constantsModule.cookieToken)
            };
        } else {
            Object.assign(data, { "access_token": this._cookieService.get(this._constantsModule.cookieToken) });
        }
        this._httpClient.post(this._constantsModule.serverFullURL + url, data, this._constantsModule.httpOptions).subscribe(
            (data) => {
                cbOk(data);
            },
            (err) => {
                if (err.status == 401) {
                    this.closeConnexion();
                    this.router.navigateByUrl('/login');
                } else {
                    cbKo(err);
                }
            }
        );
    }

    /**
     * Dialog handler.
     * @param DlgClass 
     * @param cbDone 
     * @param cbReason 
     */
    public runModalDialog(DlgClass: any, cbDone: any, cbReason: any): void {
        // Display a dialog box.
        this._modalService.open(DlgClass, {'keyboard':false, 'backdrop':'static'}).result.then((result) => {
            cbDone(result);
        }, (reason) => {
            cbReason(reason);
        });
    }

    /**
     * 
     * @param DlgClass 
     * @param data 
     * @param cbDone 
     * @param cbReason 
     */
    public runModalDialogWithParameters(DlgClass: any, data: any, cbDone: any, cbReason: any): void {
        // Display a dialog box by sending it data.
		data["backdrop"] = 'static';
		data["keyboard"] = false;
        let modal = this._modalService.open(DlgClass, data);
        // Sending data to the component.
        // DlgClass requires the interface modalWithParameter !
        modal.componentInstance.setModalOptions(data);
        modal.result.then((result) => {
            cbDone(result);
        }, (reason) => {
            cbReason(reason);
        });
    }
}
